/**
 * Downloads a file from a blob response
 * @param blob - The blob data to download
 * @param filename - The name of the file to download
 */
export function downloadFile(blob: Blob, filename: string): void {
  // Create a temporary URL for the blob
  const url = window.URL.createObjectURL(blob);

  // Create a temporary anchor element to trigger the download
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the temporary URL
  window.URL.revokeObjectURL(url);
}
